module.exports = __webpack_public_path__ + "static/media/screenshot_history_2_en.5834c44c.png";